module.exports = "./img/1e7339c20f072692af15b10c18e0ca31.jpg";